import { createRouter, createWebHistory } from "vue-router";

const routes = [
  {
    path: "/login",
    name: "login",
    component: () => import("../views/LoginView.vue"),
  },
  {
    path: "/",
    component: () => import("../views/guest/layouts/LayoutView.vue"),
    children: [
      {
        path: "/books",
        component: () => import("../views/guest/BooksView.vue"),
      },
      {
        path: "",
        component: () => import("../views/guest/HomeView.vue"),
      },
      {
        path: "/about",
        component: () => import("../views/guest/AboutView.vue"),
      },
      {
        path: "/contact",
        component: () => import("../views/guest/ContactView.vue"),
      },
      {
        path: "/projects",
        component: () => import("../views/guest/ProjectsView.vue"),
      },
      {
        path: "/team",
        component: () => import("../views/guest/TeamView.vue"),
      },
      {
        path: "/team/member/:id",
        component: () => import("../views/guest/TeamMember.vue"),
      },
      {
        path: "/projects/details/:id",
        component: () => import("../views/guest/ProjectDetails.vue"),
      },
      {
        path: "/craftsmen/:id",
        component: () => import("../views/guest/CraftsmanView.vue"),
      },
      {
        path: "/articles",
        component: () => import("../views/guest/CraftsmanArticles.vue"),
      },
      {
        path: "/articles/:id",
        component: () => import("../views/guest/CraftsmanOneArticle.vue"),
      },
    ],
  },

  {
    path: "/admin",
    name: "admin",
    meta: {
      auth: true,
    },
    component: () => import("../views/admin/layouts/LayoutView.vue"),

    children: [
      {
        path: "",
        component: () => import("../views/admin/AdminHome.vue"),
      },
      {
        path: "crafts",
        component: () => import("../views/admin/AdminCrafts.vue"),
      },
      {
        path: "craftsmen",
        component: () => import("../views/admin/AdminCraftsmen.vue"),
      },
      {
        path: "cities",
        component: () => import("../views/admin/AdminCities.vue"),
      },
      {
        path: "team",
        component: () => import("../views/admin/AdminTeam.vue"),
      },
      {
        path: "messages",
        component: () => import("../views/admin/AdminMessages.vue"),
      },
      {
        path: "articles",
        component: () => import("../views/admin/AdminArticles.vue"),
      },
    ],
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach((to, from, next) => {
  const sessionLoggedIn = () =>
    localStorage.getItem("user") != null ? true : false;
  //const user = JSON.parse(localStorage.getItem("user"));

  // console.log("user", user);
  // console.log("to", to);

  if (to.path == "/login" && sessionLoggedIn()) {
    next("/admin");
    return;
  }
  if (to.meta.auth && !sessionLoggedIn()) {
    next("/login");
    return;
  }
  next();
});

export default router;
